<template>
  <q-layout view="lHh Lpr lFf" style="height: 100%">
    <q-page-container>
      <div class="q-pa-md" style="height: 100%">
        <router-view />
      </div>
    </q-page-container>
  </q-layout>
</template>

<script>
import { ref } from 'vue';

export default {
  name: 'LayoutDefault',

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  setup() {
    return {
      leftDrawerOpen: ref(false),
    };
  },
};
</script>
<style>
html {
  height: 100%;
}
</style>
